import {Component,Inject} from 'ng-metadata/core';

import {AccountOverviewService} from '../overview/accountOverview.service';

const includes= require('lodash/includes');
var angular:angular.IAngularStatic =  require('angular');

@Component({
	"selector": 'prm-deposits-link',
	templateUrl: 'components/account/depositsLink/deposits-link.html',
})

//put in @Inject all objects you need in the constructor. ng-forward objects should be injected as is. angular1 modules
@Inject(AccountOverviewService)
export class PrmDepositsLink{

	constructor(private accountOverviewService: AccountOverviewService) {
    	this.accountOverviewService.updateCounters();
	}

    get depositsCounter(){
    	return this.accountOverviewService.depositsCounter;
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/account/depositsLink/depositsLink.directive.ts